import { render } from "./ParticlesBackground.vue?vue&type=template&id=1da3ecaa&scoped=true"
import script from "./ParticlesBackground.vue?vue&type=script&lang=js"
export * from "./ParticlesBackground.vue?vue&type=script&lang=js"

import "./ParticlesBackground.vue?vue&type=style&index=0&id=1da3ecaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1da3ecaa"]])

export default __exports__